export default {

    // меню
    'Заявки': 'درخواست ',
    Заказы: 'سفارش',
    'Новый заказ': 'سفار ش جدید',
    'Билеты в музеи': 'بلیط موزه',
    'Подать график': 'ارسال نمودار',
    'Радио/Аудиогид': 'هد ست یا رادیو گاید',
    Архив: 'آرشیو',
    Отчеты: 'گزارش',
    Сверка: 'تطبیق کردن',
    Оплата: 'واریزی',
    'Оплата Wechat': 'وار یزی از طریق ویچت',
    'Оплата заявок': 'واریزی درخواستها',
    'История платежей': 'کل واریزی ها',
    'Прайс-лист': 'لیست قیمتها ',
    'Продление лицензий': 'تمدید مجوز ها',
    'Мои лицензии': 'مجوز من ',
    Продление: 'تمدید',
    Информация: 'اطلاعات',
    Новости: 'اخبار ',
    Транспорт: 'وسیله نقلیه',
    'О компании': 'درمورد کمپانی',
    Договор: 'قرارداد',
    'Договор оферты': 'پیش قرارداد',
    'Политика возврата': 'شرایط برگرداندن',
    'Поиск по ref, номеру заявки, дате или объекту': 'جستحو با رفرنس شماره درخواست .زمان ویا مکان ',
    Настройки: 'تنظیمات',
    Помощь: 'کمک ',
    'Обратная связь': 'پیگیری تماس',
    Выйти: 'خروج',
    'Старая версия сайта': 'نسخه قدیمی سایت ',
    'ООО «АВАНГАРД ТРАВЕЛ ГРУПП»': 'شرکت آوانگارد تراول گروپ',

    // заказы
    'Нет предстоящих заказов': 'سفارش جدیدی وجود ندارد',
    'Выберите форму заказа': 'نحوه سفارش را انتخاب کنید',
    'Заказать билеты в музей': 'سفارش بلیلط برای موزه',
    'Заказать Радио/Аудиогиды': 'سفارش هد ست یا رادیو گاید',
    Заявка: 'درخواست ',
    'В обработке': 'در حال پردازش',
    'Подтврждена': 'مورد تایید',
    'Лист ожидания': 'لیست انتظار',
    'Аннулирована': 'لغو شده',
    'Отклонена': 'قطع شده است ',
    'Подтвержденное время:': 'زمان تایید شده ',
    'Вход': 'ورود',
    'ПОДРОБНЕЕ': 'شرح کامل',
    'ИЗМЕНИТЬ': 'عوض کردن',
    'ГДЕ СОТРУДНИК': 'همکار کجا هست ',
    'АННУЛИРОВАТЬ': 'لغو کردن',
    'В АРХИВ': 'داخل آرشیو',
    'Сотрудник на объекте': 'همکار ما در محل میباشد',
    'Сотрудник не на объекте': 'همکار ما در محل نمیباشد',
    'Но вы можете связаться с нами:': 'شما میتوانید با ما در تماس باشید',
    'Аннулировать': 'لغو کردن',
    'Хотите аннулировать заявку?': 'میخواهید درخواست را لغو بکنید؟',
    'Аннулированная заявка попадет в архив и восстановить ее будет невозможно': 'اگردرخواست را لغو کنیددرخواست شما وارد آرشیو میشود وبازیابی امکان ندارد',
    'Отмена': 'لغو کردن',
    'Дата и время:': 'تاریخ و زمان ',
    'Имя гида:': 'اسم راهنما',
    'Не заполнено': 'کامل پر نشده است ',
    'Телефон гида:': 'شماره تلفن راهنما',
    'Пожелания:': 'با میل شما',
    'Подтвержденное время и вход:': 'تایید زمان ورودی',
    'Билеты:': 'بلیط ها',
    'Дополнительные услуги:': 'خدمات اضافی',
    'Причина отклонения:': 'علت قطع شدن',
    'Информация о группе:': 'اطلاعات گروه ',
    'Доп.услуги:': 'خدمات اضافی',
    'Доп.информация:': 'اطلاعات اضافی',
    'График': 'برنامه و نمودار',
    'Гид': 'راهنما',
    'Заказать': 'سفارش دادن',

    // новый заказ
    'Информация о музее': 'اطلاعات در مورد موزه',
    'Выберите категорию группы (РФ или ИГ), музей, дату и время': 'انتخاب نوع گروه(روسی یا خارجی)موزه تاریخ و زمان',
    'Выберите категорию группы': 'انتخاب نوع گروه ',
    'Выберите музей': 'انتخاب موزه',
    'Выберите объект': 'انتخاب مکان',
    Далее: 'بعدی',
    'Выберите дату': 'تاریخ را انتخاب کنید',
    'Выберите время': 'زمان را انتخاب کنید ',
    'Информация о группе': 'اطلاعات گروه ها',
    'Выберите кол-во билетов': 'تعداد بلیط را انتخاب کنید',
    'Выберите страну': 'کشور مورد نظر را انتخاب کنید',
    Назад: 'برگشت ',
    'Доп. услуги': 'خدمات اضافی',
    'Выберите дополнительные услуги': 'خدمات اضافی را انتخاب کنید',
    'Кол-во гидов сопровождающих (если нет лицензии)': 'تعداد راهنماهایی که همراه گروه هستند(اگر مجوز ندارند)',
    'Необходим если у гида нет лицензии в выбранный музей': 'لازم هست اگر راهنما مجوز موزه مورد نظر را ندارد',
    'Доп. информация': 'اطلاعات اصافی',
    'Информация о гиде и пожелания': 'اطلاعات در مورد راهنما و نیازها',
    'Ref номер (необязательно)': 'شماره رفرنس (لارم نیست)',
    'Уникальный номер группы / вспомогательный номер для ваших целей': 'شماره منحصر بفرد گروه این شماره به خود شما کمک میکند',
    'Имя гида': 'اسم راهنما',
    'Телефон гида': 'شماره تلفن راهنما',
    Пожелания: 'انتظارات',
    'В поле "Пожелания" укажите:': 'در سطر انتظارات بنویسید',
    'адрес и время получения': 'آدرس و زمان دریافت ',
    'адрес и приблизительное время возврата оборудования': 'آدرس و زمان تقریبی برگرداندان تجهیزات ',
    Отправить: 'بفرستید',
    'Пожалуйста, ожидайте': 'خواهش میکنم منتظر باشید',
    'Успешно!': 'با موفقیت انجام شد',
    'Заказ создан': 'سفارش شما شکل گرفت',
    'Ошибка:': 'اشتباه ',
    Ок: 'اکی ',
    'Кол-во взрослых': 'تعداد بزرگسالان',
    'Кол-во детей': 'تعدا د کودکان',
    'итого:': 'مجموع',
    'чел. (надо': 'نفر',
    'экскурс.обсл.)': 'خدمات گشتها',
    'гид. или сопровожд.)': 'راهنما و یا فرد همراه',
    'Радиогид': 'صدا رسان یا رادیو گاید',
    'Экскурсия ведется лицензионным гидом': 'راهنمای مجوز دار گشت را اجرا میکند',
    'Аудиогид': 'صدارسان ',
    'Экскурсия ведется при помощи технических средств на языке группы': 'برنامه گشت با کمک تجهیزات مخصوص و به زبان گروه مورد نظر اجرا میشود',
    'Кол-во гидов с лицензией': 'تعداد راهنماهای مجوز دار',
    'Кол-во сопровождающих': 'تعداد همراههای گروه',
    'Удалить': 'حذف کردن',
    'Отправить заказ': 'سفارش را فرستادن',
    'Добавить группу': 'گروه را اضافه کنید',
    'Группа': 'گروهها',

    // архив
    'Номер заявки или ref': 'شماره درخواست یا رفرنس',
    Объект: 'اسم موزه ',
    'Номер заявки': 'شماره درخواست ',
    Все: 'همه',
    'Дата посещения с': 'زمان بازدید از تاریخ',
    'Дата посещения по': 'زمان بازدید تا تاریخ ',
    Найти: 'پیدا کردن',
    'Заказов согласно фильтру не найдено': 'سفارش شمابرطبق فیلتری که هست پیدا نشد',
    Ошибка: 'اشتباه ',
    'Любой номер': 'شماره دلخواه',

    // сверка
    Сформировать: 'شکل دادن ',
    'Файл сверки': 'فایل تطبیق',
    'Для скачивания сформированного файла сверки нажмите на конпку "Скачать".': 'برای دانلود کردن (فایل تطبیق )بر روی دگمه دانلود فشار دهید',
    'Скачать': 'دانلو دکردن',

    // оплата заявок
    'Оплатить заявки': 'پرداخت کردن درخواست ',
    'Номера ваучеров или заявок для оплаты (через запятую)': 'شماره والچر یا درخواست برای پرداخت (باورگول )',
    'Введите номера ваучеров или заявок для оплаты': 'برا ی واریزی شماره والجر یا درخواست را وارد کنید',
    'ФИО или название организации': 'اسم و فامیلی ویا اسم کمپانی',
    'Введите ФИО или название организации': 'اسم و فامیلی و یا اسم کمپانی را بنویسید',
    Email: ' امیل',
    'Введите Email': 'امیل خودتان را بنویسید',
    'Сумма к оплате': 'مبلغ و یا پرداختی',
    'Введите сумму к оплате': 'مبلغ واریزی را بنویسید',
    'Согласен с договором оферты': 'با پیش قرار داد موافق هستید',
    'Перейти к оплате': 'ورود برای واریزی',
    'Подождите,': 'صبر کنید,',
    'принимаем': 'قبول میکنیم',
    'оплату...': 'و اریزی',
    'Заказ успешно оплачен!': 'سفارش شما با موفقیت پرداخت شد',
    'Ваш заказ': 'شماره سفارش ',
    'успешно оплачен. Спасибо за покупку!': 'با موفقیت پرداخت شد با تشکر ازخرید شما',
    'Что-то пошло не так!': 'درست انجام نشد',
    'При оплате заказа': 'درزمان پرداخت سفارش',
    'произошла ошибка!': 'اشتباه شد',
    'Cчет успешно сформирован!': 'صورت حساب با موفقیت شکل گرفته است ',
    'Вы можете открыть его нажав кнопку ниже': 'با فشار دگمه پایین شما میتوانید آن را باز کنید',
    'Открыть счет': 'باز کردن حساب بانکی',
    'Физическим лицам': 'حساب شخصی ',
    'Юридическим лицам': 'حساب برای شرکت ',
    'Для формирования счета на оплату введите номера ваучеров или заказов, укажите реквизиты компании и точную сумму:': 'برای اماده کردن واریزی شماره والجر ویا سفارش ومشخصات حساب و مبلغ دقیق را وارد کنید',
    'Для оплаты введите номера ваучеров или заявок и укажите точную сумму для оплаты:': 'برای پرداخت شماره والچرو یا سفارش و مشخصات حساب و مبلغ دقیق را وارد کنید',
    'Название организации': 'اسم کمپانی',
    'Юридический адрес': 'آدرس حقوقی کمپانی',
    'Сформировать счет': 'آماده کردن حساب بانکی',
    'Расчетный счет': 'حساب بانکی',
    'ИНН': 'ای ان ان',
    'КПП': 'ک پ پ',
    'Банк': 'بانک',
    'Полное название банка (для формирования акта). Например: ': 'اسم کامل بانک برای صورت حساب پرکردن',
    'БИК Банка': 'شماره بیک بانک',
    'Корреспондентский счет': 'حساب کورس پاندنسکی',

    // история платежей
    'Номер платежа': 'شماره قبض پرداختی ',
    Ваучеры: 'والچر ها',
    'Способ оплаты': 'روش پرداخت ',
    'Время и дата оплаты': 'زمان و تاریخ پرداختی ها',
    Сумма: 'مبلغ ',
    Статус: 'مرحله',
    'Платежи отсутствуют': 'قبض پرداختی وجود ندارد',

    // прайс-лист
    'Прайс-лист для иностранных групп': 'قیمتها برای گروههای خارجی ',
    'Актуальный файл с ценами для иностранных групп.': 'فایل واقعی با قیمت برای گروههای خارجی ',
    Открыть: 'باز',
    'Прайс-лист для российских групп': 'قیمتها برای گروههای روسی ',
    'Актуальный файл с ценами для российских групп.': 'فایل واقعی باقیمت برای گروههای روسی ',

    // лицензии
    'Добавить лицензию': 'مجوز را اضافه کنید',
    'В настоящий момент нет сохраненных лицензий, вы можете добавить их.': 'درحال حاضرمجوز شما نگهداری نشده هست میتوانید اضافه کنید',
    'Добавить': 'اضافه کردن',
    'Музей': 'موزه',
    'Номер лицензии': 'شماره مجوز',
    'Стаж (лет)': 'تجریه کاری (سال)',
    'Дата окончания': 'زمان تمام شدن',
    'Основной язык': 'زبان اصلی',
    'Дополнительные языки': 'زبان بعدی',

    // о компании
    'ИНН:7841027155': ' ای ان ان 7841027155',
    'КПП: 784101001': 'ک پ  پ 784101001',
    'ОГРН: 1157847276003': 'ا گ رن1157847276003',
    'ОКПО: 25885413': 'ا ا ک پ ا 25885413',
    'Расчетный счет: 40702810603260000188': 'شماره حساب40702810603260000188',
    'Банк: Филиал "Центральный" Банка ВТБ (ПАО)': 'بانک مرکزی و ت ب',
    'БИК: 044525411': 'بیک 044525411',
    'Корр. счет: 30101810145250000411': 'حساب کر 30101810145250000411',
    'Юридический адрес: 191186, Санкт-Петербург г, вн.тер. г. муниципальный округ Дворцовый округ, наб Канала Грибоедова, д. 5, литера Е, помещ. Ч.ПОМ. 19-Н ОФ.405': 'آدرس حقوقی کمپانی 191186سنت پتربورگ کانال گریبایدوا ساختمان 5 شماره 405',
    'Email: info@avangard-travel.ru': 'امیلinfo@avangard-travel.ru   ',
    'Телефон: (812) 640-02-28': 'تلفن 8126400228',

    // договор
    'Вы можете посмотреть договор с ООО "Авангард Травел Групп".': 'شما میتوانید به قرارداد با شرکت آوانگارد نگاه کنید',

    // договор оферты
    'Вы можете посмотреть договор оферты с ООО "Авангард Травел Групп".': 'شما میتوانید به پیش قرارداد با شرکت آوانگارد نگاه کنید',

    // политика возврата
    'Вы можете посмотреть политику возврата.': 'شما میتوانید به روش کنسلی نگاه کنید',

    // настройки
    'Имя:': '',
    'Телефон:': 'شماره تلفن ',
    'Страна:': 'کشور',
    'Информация о гиде': 'اطلاعات راهنما',
    'Заполните информацию и подавайте заявки еще быстрее': 'اطلاعات را پرکنید و درخواست را سریعتر ارسال کنید',
    Имя: 'اسم ',
    Телефон: 'شماره تلفن',
    'Выберите страницу': 'کشور را انتخاب کنید',
    'Использовать в заказе?': 'در سفارش استفاده شود؟',
    Сохранить: 'ذخیره',
    'Являетесь ли вы туристической фирмой / юридическим лицом': 'آیا شما شرکت توریستی هستید شرکت حقوقی هستید',
    'Юридическое лицо': 'شرکت حقوقی',
    'Для выставления счетов': 'برای ارسال صورت حساب',

    // форма логина
    Логин: 'لوگین ',
    Пароль: 'پارول',
    Войти: 'وارد شدن',
    'Выберите язык': 'انتخاب زبان',
    'У вас нет аккаунта?': 'شما حساب کاربری ندارید؟',
    'Зарегистрироваться': 'ثبت کردن',
    'Добро пожаловать!': 'خوش آمدید',
    'Будем рады видеть вас среди наших клиентов! Пожалуйста, уделите немного времени на заполнение формы ниже. Вскоре мы отправим вам все необходимые инструкции на указанный адрес электронной почты.': '-از اینکه شما را دربین مشتریانمان میبینیم خوشحال هستیم ،خواهشمندم برای پر کردن فرم زیر کمی وقت بگذارید،به امیل شما ما دستورالعمل لازم را میفرستیم',
    'Фамилия': 'فامیلی',
    'Физ.лицо': 'شخصی ',
    'Юр.лицо': 'شرکتی',
    'Отчество': 'اسم پدر',
    'У вас есть аккаунт?': 'شما حساب کاربری دارید؟',
    'Название фирмы': 'اسم شرکت ',
    'БИК': 'БИК',
    'ФИО контактного лица': 'فامیلی و اسم مخاطب',
    'Заявка принята!': 'درخواست شما پذیرفته شد',
    'Спасибо за вашу заявку! В ближайшее время на указанный вами адрес электронной почты мы отправим все необходимые инструкции.': 'با تشکر از درخواست شما،به زودی به امیل شما  دستورالعمل لازم را میفرستیم',

    // уведомление
    'Теперь можно оплатить заявки онлайн, включая оплату от юридических лиц!': 'الان میتوانید درخواست را به نام کمپانی  انلاین پرداخت کنید ',
    'Мы рады сообщить, что теперь вы можете оплатить заявки на нашем сайте, используя банковскую карту или QR-код системы быстрых платежей. Вдобавок к этому, мы расширили наши возможности и теперь доступна оплата и для юридических лиц. Юридические лица могут самостоятельно генерировать счета для оплаты.': 'با استفاده از کارت بانکی و بارکد میتوانید پرداختی را انجام بدهید',
    'Никаких задержек и лишних хлопот - оплата проходит мгновенно. Перейдите в раздел "Оплата заявок" и оплачивайте свои заявки быстро и удобно! Наши новые возможности сделают процесс ещё более удобным и эффективным.': 'واریزی بدون وقفه انجام میشود',
    Закрыть: 'بسته',

    // помощь
    'У вас есть вопросы?': 'آیا شما سوال دارید؟',
    'Если вы не можете найти ответ на вопрос, вы всегда можете связаться с нами. Мы ответим вам в ближайшее время!': ' اگرجواب سوال خودتان را پیدا نکردید همیشه میتوانید به ما زنگ بزنید ما سریع جواب میدهیم',
    'Мы всегда рады помочь!': 'خوشحال میشویم که همیشه به شما کمک کنیم',
    'Лучший способ получить ответ быстрее!': 'بهترین روش برای اینکه سریع جواب خود را بگیرید',

    // в разработе
    'Готовимся к запуску. Новая функция в пути! 🚀': 'آماده برای راه اندازی،طرح جدید در راه هست ',
    'Мы активно работаем над новой функцией для вас.': 'ما فعالانه برای شما بر روی طرح جدید کار میکنیم ',
    'Будьте в курсе предстоящих обновлений!': 'در جریان روز رسانی های ما باشید',

    // Обратная связь
    'Мы всегда рады услышать вас!': 'ما همیشه ازتوجهات شما خوشحال میشویم ',
    'Наши усилия направлены на то, чтобы сделать систему подачи заявок максимально удобной и эффективной для вас. Ваше мнение и предложения играют ключевую роль в этом процессе. Не стесняйтесь делиться своими мыслями, идеями, а также сообщать нам обо всех замеченных ошибках или проблемах в работе системы. Вместе мы сделаем систему подачи заявок лучше!': 'تلاش ما بر این است که سیستم برنامه کاربردی را تا حد امکان برای شما راحت و کارآمد کنیم. نظرات و پیشنهادات شما نقش اساسی در این فرآیند دارد. در صورت تمایل نظرات، ایده های خود را به اشتراک بگذارید و همچنین هرگونه خطا یا مشکلی را که در سیستم مشاهده می کنید با ما در میان بگذارید. ما با هم سیستم برنامه را بهتر خواهیم کرد!',
    'Как к вам обращаться?': 'اسم شما یا اسم کمپانی شما چی هست',
    'Email для обратной связи': 'امیل خودنان را بنویسید تا با شما تماس داشته باشیم ',
    'Опишите ваше предложение, жалобу или замеченную ошибку': 'پیشنهادات و نظریات و شکایات و یا اشتباه ما را بنویسید',
    'Мы используем файлы cookie, чтобы сайт работал и был удобнее. Оставаясь на сайте, вы соглашаетесь на их использование.': 'ما از کوکی‌ها استفاده می‌کنیم تا سایت درست کار کند و راحت‌تر باشد. با ادامهٔ استفاده از سایت، با کاربرد آن‌ها موافقت می‌کنید.',
    'Хорошо': 'باشه',
    'Подача графика на {month} закрывается {deadline}.': 'ارسال نمودار برای {month} در {deadline} بسته می‌شود.',
    'Россия': 'روسیه',

    // оплата лицензий
    'Оплата продления': 'پرداخت تمدید',
    'Оплатить': 'پرداخت',
    'К заказам': 'به سفارش‌ها',
    'Повторить': 'تلاش دوباره',
    'Выбор лицензий': 'انتخاب مجوزها',
    'Выберите одну или несколько лицензий для оплаты': 'یک یا چند مجوز را برای پرداخت انتخاب کنید',
    'Сезон продления: приём заявок с {start} по {finish}': 'فصل تمدید: پذیرش درخواست‌ها از {start} تا {finish}',
    'Выберите лицензии': 'مجوزها را انتخاب کنید',
    'Нет лицензий для оплаты': 'مجوزی برای پرداخت وجود ندارد',
    'Итого к оплате': 'جمع قابل پرداخت',
    'Плательщик': 'پرداخت‌کننده',
    'ФИО и email, на который придёт чек': 'نام کامل و ایمیلی که رسید به آن ارسال می‌شود',
    'Проверьте список лицензий и перейдите к оплате': 'فهرست مجوزها را بررسی کنید و به پرداخت بروید',
    'Лицензия № {no}': 'مجوز شماره {no}',
    'После оплаты менеджер получит уведомление и отметит оплату. Чек придёт на указанный email.': 'پس از پرداخت، مدیر اعلان دریافت می‌کند و پرداخت را ثبت می‌کند. رسید به ایمیل واردشده ارسال می‌شود.',
    'Продление уже оплачено': 'تمدید قبلاً پرداخت شده است',
    'Оплачено на сайте, ждёт подтверждения менеджера': 'در سایت پرداخت شده، در انتظار تأیید مدیر',
    'Оплата лицензий пока недоступна.': 'پرداخت مجوزها هنوز در دسترس نیست.',
    'Цены на лицензии ещё не опубликованы. Попробуйте позже или свяжитесь с менеджером.': 'قیمت مجوزها هنوز منتشر نشده است. بعداً دوباره تلاش کنید یا با مدیر تماس بگیرید.',
    'Не удалось получить список лицензий. Попробуйте ещё раз.': 'دریافت فهرست مجوزها ممکن نشد. دوباره تلاش کنید.',
    'Не удалось создать счёт на оплату. Попробуйте ещё раз.': 'ایجاد صورت‌حساب پرداخت ممکن نشد. دوباره تلاش کنید.',
    'Список лицензий или цены изменились. Обновите страницу и выберите лицензии заново.': 'فهرست مجوزها یا قیمت‌ها تغییر کرده است. صفحه را تازه کنید و مجوزها را دوباره انتخاب کنید.',
    'Введите email': 'ایمیل را وارد کنید',
    'Введите ваш email': 'ایمیل خود را وارد کنید',
    'Продление этой лицензии сейчас закрыто': 'تمدید این مجوز در حال حاضر بسته است',
    'Укажите язык лицензии в разделе «Мои лицензии»': 'زبان مجوز را در بخش «مجوزهای من» مشخص کنید',
    'Заявка на продление подана': 'درخواست تمدید ثبت شده است',
    'Заявка на продление будет подана автоматически': 'درخواست تمدید به‌طور خودکار ثبت می‌شود',
    'Заявку на продление оформит менеджер': 'درخواست تمدید را مدیر ثبت می‌کند',
    'Добавьте свои лицензии в раздел «Мои лицензии», и заявки на продление будут подаваться автоматически.': 'مجوزهای خود را به بخش «مجوزهای من» اضافه کنید تا درخواست‌های تمدید خودکار ثبت شوند.',
    'Консультационные услуги (лицензии)': 'خدمات مشاوره (مجوزها)',
    'Продление или первичное получение, затем музей': 'تمدید یا دریافت اولیه، سپس موزه',
    'Первичное получение': 'دریافت اولیه',
    'первичное получение': 'دریافت اولیه',
    'Оплата в офисе': 'پرداخت در دفتر',
    'Итого к оплате на сайте': 'جمع قابل پرداخت در سایت',
    'ФИО для договора, телефон и email, на который придёт чек': 'نام کامل برای قرارداد، تلفن و ایمیل دریافت رسید',
    'ФИО': 'نام کامل',
    'Фамилия Имя Отчество': 'نام خانوادگی، نام، نام پدر',
    'Введите ФИО полностью': 'نام کامل را وارد کنید',
    'Контактный телефон': 'تلفن تماس',
    'Введите корректный телефон': 'شماره تلفن معتبر وارد کنید',
    'Договор и оплата': 'قرارداد و پرداخت',
    'Проверьте список, подтвердите договор и перейдите к оплате': 'فهرست را بررسی کنید، قرارداد را تأیید کنید و به پرداخت بروید',
    'Заявки на продление поданы.': 'درخواست‌های تمدید ثبت شدند.',
    'Оплата этих лицензий производится в офисе. Для справок свяжитесь с менеджером по телефону {phone}.': 'پرداخت این مجوزها در دفتر انجام می‌شود. برای اطلاعات با مدیر به شماره {phone} تماس بگیرید.',
    'Договор оказания услуг': 'قرارداد ارائه خدمات',
    'Не удалось получить текст договора. Попробуйте ещё раз.': 'دریافت متن قرارداد ممکن نشد. دوباره تلاش کنید.',
    'Я принимаю условия договора возмездного оказания услуг': 'شرایط قرارداد ارائه خدمات در ازای پرداخت را می‌پذیرم',
    'Подать заявки': 'ثبت درخواست‌ها',
    'Выбор группы откроется после оплаты продления.': 'انتخاب گروه پس از پرداخت تمدید باز می‌شود.',
    'Оплатить продление': 'پرداخت تمدید',
    'Продление оплачено на сайте.': 'تمدید در سایت پرداخت شده است.',
    'Не удалось записаться в группу. Попробуйте ещё раз.': 'ثبت‌نام در گروه ممکن نشد. دوباره تلاش کنید.',
    'Выбрать группу': 'انتخاب گروه',
    'Теперь можно выбрать группу для занятий: она появится в карточке музея на странице «Продление», как только менеджер назначит даты.': 'اکنون می‌توانید گروه جلسات را انتخاب کنید: به‌محض تعیین تاریخ توسط مدیر، در کارت موزه در صفحه «تمدید» نمایش داده می‌شود.',
    'Тестовый режим': 'حالت آزمایشی',
    'Раздел проверяется, оплачивать лицензии через сайт пока не нужно.': 'این بخش در حال آزمایش است؛ فعلاً نیازی به پرداخت هزینه مجوزها از طریق سایت نیست.',
    'истекла': 'منقضی شده',
    'Не удалось удалить лицензию. Попробуйте ещё раз.': 'حذف مجوز انجام نشد. لطفاً دوباره تلاش کنید.',
    'Не удалось добавить лицензию. Попробуйте ещё раз.': 'افزودن مجوز انجام نشد. لطفاً دوباره تلاش کنید.',
    'Расписание занятий': 'برنامه جلسات',
    'Расписание занятий пока не опубликовано.': 'برنامه جلسات هنوز منتشر نشده است.',
    'Расписание занятий появится после записи.': 'برنامه جلسات پس از ثبت‌نام نمایش داده می‌شود.',
    'Стоимость занятий': 'هزینه جلسات',
    'Записаться на продление': 'ثبت‌نام برای تمدید',
    'Оплатить занятия': 'پرداخت هزینه جلسات',
    'Выбрать дату занятий': 'انتخاب تاریخ جلسه',
    'Подать заявку на продление: {museum}? После этого станет видно расписание занятий.': 'درخواست تمدید ثبت شود: {museum}؟ پس از آن برنامه جلسات نمایش داده می‌شود.',
    'Продление по этому музею сейчас закрыто.': 'تمدید برای این موزه در حال حاضر بسته است.',
    'Укажите в лицензии язык: без него заявку не принять. Это можно сделать через «Изменить».': 'لطفاً زبان را در مجوز مشخص کنید؛ بدون آن درخواست پذیرفته نمی‌شود. این کار از طریق «Изменить» ممکن است.',
    'Лицензия продлена.': 'مجوز تمدید شد.',
    'Заявка на продление подана.': 'درخواست تمدید ثبت شد.',
    'Занятия оплачены.': 'هزینه جلسات پرداخت شده است.',
    'Занятия оплачены на сайте, менеджер подтвердит оплату.': 'هزینه جلسات در سایت پرداخت شد؛ مدیر پرداخت را تأیید خواهد کرد.',
    'Вы записаны на занятия: {group}.': 'شما در جلسات ثبت‌نام کرده‌اید: {group}.',
    'Не удалось подать заявку. Попробуйте ещё раз.': 'ثبت درخواست انجام نشد. لطفاً دوباره تلاش کنید.',
    'Занятия оплачены. Выберите дату занятий в карточке: {museums}.': 'هزینه جلسات پرداخت شد. تاریخ جلسه را در کارت انتخاب کنید: {museums}.',
    'Укажите язык лицензии на странице «Продление лицензий»': 'زبان مجوز را در صفحه «تمدید مجوز ها» مشخص کنید',
    'Сначала добавьте лицензию на странице «Продление лицензий»': 'ابتدا مجوز را در صفحه «تمدید مجوزها» اضافه کنید',
    'Оплата возвращена, можно оплатить заново': 'پرداخت بازگردانده شد، می‌توانید دوباره پرداخت کنید',
    'свободно {free} из {limit}': '{free} از {limit} جا خالی',
    'мест нет': 'جا نیست',
    'Добавьте свои лицензии на странице «Продление лицензий», и заявки на продление будут подаваться автоматически.': 'مجوزهای خود را در صفحه «تمدید مجوز ها» اضافه کنید تا درخواست‌های تمدید به‌طور خودکار ثبت شوند.',
    'Теперь можно выбрать дату занятий по расписанию: откройте карточку лицензии на странице «Продление лицензий».': 'اکنون می‌توانید تاریخ جلسه را طبق برنامه انتخاب کنید: کارت مجوز را در صفحه «تمدید مجوز ها» باز کنید.',
    'Лицензии': 'مجوزها',
    'Подать заявку': 'ثبت درخواست',
    'Выбрать': 'انتخاب',
    'Стоимость пока не указана.': 'هزینه هنوز مشخص نشده است.',
    'Лицензии на этот музей нет в кабинете. Добавьте её, чтобы записаться на продление и оплатить занятия.': 'مجوزی برای این موزه در حساب شما نیست. آن را اضافه کنید تا برای تمدید ثبت‌نام کنید و هزینه جلسات را بپردازید.',
    'Музеи, где у вас нет лицензии': 'موزه‌هایی که برای آن‌ها مجوز ندارید',
    'С окончания срока действия лицензии прошло 3 года. Просьба обратиться к менеджеру за консультацией.': 'سه سال از انقضای مجوز گذشته است. لطفاً برای مشاوره با مدیر تماس بگیرید.',
    'Прошло три года после окончания лицензии — нужно первичное обучение': 'سه سال از انقضای مجوز گذشته — آموزش اولیه لازم است',
    'Просим вас вписать ФИО полностью и кириллицей: это нужно для соблюдения законодательства РФ.': 'لطفاً نام کامل خود را با حروف سیریلیک (روسی) بنویسید: این طبق قوانین روسیه لازم است.',
    'Введите ФИО кириллицей — допустимы только буквы, пробел и дефис': 'نام کامل را با حروف سیریلیک (روسی) وارد کنید — فقط حروف، فاصله و خط تیره مجاز است',
    'Оплатите занятия и после этого выберите дату и время.': 'ابتدا هزینه کلاس‌ها را پرداخت کنید و سپس تاریخ و ساعت را انتخاب کنید.',
    'Выбрать дату и время занятий можно будет после подтверждения менеджера.': 'پس از تأیید مدیر می‌توانید تاریخ و ساعت کلاس‌ها را انتخاب کنید.',
    'Поиск по лицензиям': 'جستجوی مجوزها',
    'Музей или номер лицензии': 'موزه یا شماره مجوز',
    'Ничего не найдено': 'چیزی پیدا نشد',
    'Договоры оказания услуг': 'قراردادهای ارائه خدمات',
    'Договор на продление': 'قرارداد تمدید',
    'Договор на первичное обучение': 'قرارداد آموزش اولیه',
    'Я принимаю условия договоров возмездного оказания услуг': 'شرایط قراردادهای ارائه خدمات با پرداخت را می‌پذیرم',
    'Email:': 'ایمیل',
    'После оплаты договор сохранится в «Настройках» и в «Истории платежей»: его можно открыть и скачать в PDF.': 'پس از پرداخت، قرارداد در «تنظیمات» و «تاریخچه پرداخت‌ها» ذخیره می‌شود: می‌توانید آن را باز کرده و PDF آن را دانلود کنید.',
    'После оплаты договоры сохранятся в «Настройках» и в «Истории платежей»: их можно открыть и скачать в PDF.': 'پس از پرداخت، قراردادها در «تنظیمات» و «تاریخچه پرداخت‌ها» ذخیره می‌شوند: می‌توانید آن‌ها را باز کرده و PDF آن‌ها را دانلود کنید.',
    'Договоры оказания услуг, которые вы подписали при оплате лицензий. Их можно открыть и скачать в любой момент.': 'قراردادهای ارائه خدماتی که هنگام پرداخت مجوزها امضا کرده‌اید. هر زمان می‌توانید آن‌ها را باز کرده و دانلود کنید.',
    'от {date}, платёж № {payment}': 'تاریخ {date}، پرداخت شماره {payment}',
    'оплата возвращена': 'وجه بازگردانده شد',
    'Скачать PDF': 'دانلود PDF',
    'Вы согласились с условиями договора и подписали его {date} в {time}, отметив «{label}».': 'شما با شرایط قرارداد موافقت کردید و آن را در {date} ساعت {time} با علامت زدن «{label}» امضا کردید.',
    'Не удалось получить договор. Попробуйте ещё раз.': 'دریافت قرارداد ممکن نشد. دوباره تلاش کنید.',

    // получение лицензий (правка начальника 02.10.2026)
    'Получение лицензий': 'دریافت مجوز',
    'Можно оплатить': 'قابل پرداخت',
    'Отметьте музеи и отправьте заявку.': 'موزه‌ها را علامت بزنید و درخواست را ارسال کنید.',
    'Дождитесь даты обучения — она появится здесь.': 'منتظر تاریخ آموزش بمانید — همین‌جا نمایش داده می‌شود.',
    'Выберите дату и оплатите обучение.': 'تاریخ را انتخاب کنید و هزینه آموزش را بپردازید.',
    'Приём заявок с {start} по {finish}': 'پذیرش درخواست‌ها از {start} تا {finish}',
    'Получение лицензий сейчас недоступно.': 'دریافت مجوز در حال حاضر در دسترس نیست.',
    'Мои заявки': 'درخواست‌های من',
    'Новая заявка': 'درخواست جدید',
    'Стоимость обучения': 'هزینه آموزش',
    'Приём заявок сейчас закрыт.': 'پذیرش درخواست‌ها در حال حاضر بسته است.',
    'Отправить заявку': 'ارسال درخواست',
    'Заявка отправлена: {museums}. Когда появится дата обучения, вы сможете выбрать её и оплатить.': 'درخواست ارسال شد: {museums}. وقتی تاریخ آموزش مشخص شود، می‌توانید آن را انتخاب و پرداخت کنید.',
    'Заявки отправлены: {museums}. Когда появится дата обучения, вы сможете выбрать её и оплатить.': 'درخواست‌ها ارسال شدند: {museums}. وقتی تاریخ آموزش مشخص شود، می‌توانید آن را انتخاب و پرداخت کنید.',
    'Заявка отправлена: {museums}. Дата обучения уже есть — выберите её в «Моих заявках» и оплатите.': 'درخواست ارسال شد: {museums}. تاریخ آموزش از قبل مشخص است — آن را در «درخواست‌های من» انتخاب و پرداخت کنید.',
    'Заявки отправлены: {museums}. Дата обучения уже есть — выберите её в «Моих заявках» и оплатите.': 'درخواست‌ها ارسال شدند: {museums}. تاریخ آموزش از قبل مشخص است — آن را در «درخواست‌های من» انتخاب و پرداخت کنید.',
    'Не удалось получить список заявок. Попробуйте ещё раз.': 'دریافت فهرست درخواست‌ها ممکن نشد. لطفاً دوباره تلاش کنید.',
    'Язык: {langs}': 'زبان: {langs}',
    'Языки: {langs}': 'زبان‌ها: {langs}',
    'Заявка подана. Дата обучения пока не назначена. Когда она появится, вы сможете выбрать дату и оплатить обучение.': 'درخواست ثبت شد. تاریخ آموزش هنوز تعیین نشده است. وقتی مشخص شود، می‌توانید تاریخ را انتخاب و هزینه آموزش را پرداخت کنید.',
    'Заявка подана. Выберите дату обучения и оплатите.': 'درخواست ثبت شد. تاریخ آموزش را انتخاب و پرداخت کنید.',
    'Заявка подана. Дата обучения: {group}.': 'درخواست ثبت شد. تاریخ آموزش: {group}.',
    'Заявка подана.': 'درخواست ثبت شد.',
    'Дата обучения': 'تاریخ آموزش',
    'Дата обучения: {group}': 'تاریخ آموزش: {group}',
    'Даты обучения': 'تاریخ‌های آموزش',
    'Оплата этого обучения производится в офисе. Для справок свяжитесь с менеджером по телефону {phone}.': 'هزینه این آموزش در دفتر پرداخت می‌شود. برای اطلاعات با مدیر به شماره {phone} تماس بگیرید.',
    'Заявка подана. Стоимость обучения пока не указана — оплата откроется позже.': 'درخواست ثبت شد. هزینه آموزش هنوز مشخص نشده است — پرداخت بعداً باز می‌شود.',
    'Обучение оплачено. Записываем вас на {date}. Если запись не появится — позвоните менеджеру: {phone}.': 'هزینه آموزش پرداخت شد. در حال ثبت‌نام شما برای {date} هستیم. اگر ثبت‌نام نمایش داده نشد، با مدیر تماس بگیرید: {phone}.',
    'Обучение оплачено.': 'هزینه آموزش پرداخت شد.',
    'Обучение оплачено. Дату обучения сообщит менеджер.': 'هزینه آموزش پرداخت شد. مدیر تاریخ آموزش را اطلاع می‌دهد.',
    'Записать вас на {date} не получилось: {reason}': 'ثبت‌نام شما برای {date} انجام نشد: {reason}',
    'Выберите другую дату.': 'تاریخ دیگری انتخاب کنید.',
    'Дату обучения сообщит менеджер: {phone}.': 'مدیر تاریخ آموزش را اطلاع می‌دهد: {phone}.',
    'Обучение оплачено. Вы записаны: {group}.': 'هزینه آموزش پرداخت شد. شما ثبت‌نام شده‌اید: {group}.',
    'Обучение пройдено.': 'آموزش به پایان رسیده است.',
    'Лицензия № {no}, действует до {date}.': 'مجوز شماره {no}، معتبر تا {date}.',
    'Оплата на сайте пока недоступна. Свяжитесь с менеджером: {phone}.': 'پرداخت در سایت هنوز در دسترس نیست. با مدیر تماس بگیرید: {phone}.',
    'Изменить языки или отменить заявку можно через менеджера: {phone}.': 'برای تغییر زبان‌ها یا لغو درخواست با مدیر تماس بگیرید: {phone}.',
    'Место в группе закрепляется после оплаты.': 'جای شما در گروه پس از پرداخت قطعی می‌شود.',
    'Выбрать дату': 'انتخاب تاریخ',
    'Оплата обучения': 'پرداخت آموزش',
    'Получаете лицензию впервые?': 'برای اولین بار مجوز می‌گیرید؟',
    'Вам в раздел «Получение лицензий»': 'به بخش «دریافت مجوز» بروید',
    'К заявкам': 'به درخواست‌ها',
    'Обучение и дата': 'آموزش و تاریخ',
    'Музей и дата обучения': 'موزه و تاریخ آموزش',
    'Музеи, по которым продлеваете лицензию': 'موزه‌هایی که مجوزشان را تمدید می‌کنید',
    'Оплата обучения на сайте пока недоступна.': 'پرداخت آموزش در سایت هنوز در دسترس نیست.',
    'Оплачивать пока нечего. Оплата откроется после заявки, когда появится дата обучения.': 'فعلاً چیزی برای پرداخت نیست. پرداخت پس از ثبت درخواست و مشخص شدن تاریخ آموزش باز می‌شود.',
    'Дата обучения ещё не назначена': 'تاریخ آموزش هنوز تعیین نشده است',
    'Выбранная дата обучения больше недоступна. Выберите дату заново.': 'تاریخ آموزش انتخاب‌شده دیگر در دسترس نیست. دوباره تاریخ را انتخاب کنید.',
    'Обучение оплачено. Запись на выбранную дату появится на странице «Получение лицензий».': 'هزینه آموزش پرداخت شد. ثبت‌نام برای تاریخ انتخاب‌شده در صفحه «دریافت مجوز» نمایش داده می‌شود.',
    'К моим заявкам': 'به درخواست‌های من',
    'К оплате продления': 'به پرداخت تمدید',
    'Появилась дата обучения: {museums}. Можно выбрать дату и оплатить.': 'تاریخ آموزش مشخص شد: {museums}. می‌توانید تاریخ را انتخاب و پرداخت کنید.',
    'Обучение оплачено, выберите дату: {museums}.': 'هزینه آموزش پرداخت شد، تاریخ را انتخاب کنید: {museums}.',
    'Перейти': 'رفتن',
    'Перейти к получению лицензии': 'رفتن به دریافت مجوز',
    'Не удалось получить список языков.': 'دریافت فهرست زبان‌ها ممکن نشد.',
    'Дата обучения прошла.': 'تاریخ آموزش گذشته است.',
    'Лицензия по этому музею у вас уже есть. Обратитесь к менеджеру.': 'شما از قبل برای این موزه مجوز دارید. با مدیر تماس بگیرید.',
    'Заявки отправлены: {museums}. Дата обучения уже есть: {dated} — выберите её в «Моих заявках» и оплатите.': 'درخواست‌ها ارسال شدند: {museums}. تاریخ آموزش برای این موارد از قبل مشخص است: {dated} — آن را در «درخواست‌های من» انتخاب و پرداخت کنید.',
    'Выберите дату обучения по каждому музею.': 'برای هر موزه تاریخ آموزش را انتخاب کنید.',
    'Система заявок сейчас не отвечает. Попробуйте через минуту.': 'سامانه درخواست‌ها اکنون پاسخ نمی‌دهد. یک دقیقه دیگر دوباره تلاش کنید.',
    'Подтвердите договор оказания услуг.': 'قرارداد ارائه خدمات را تأیید کنید.',
    'Лицензия не указана.': 'مجوز مشخص نشده است.',
    'Лицензия не найдена.': 'مجوز پیدا نشد.',
    'Выберите хотя бы одну лицензию.': 'دست‌کم یک مجوز را انتخاب کنید.',
    'Введите ФИО кириллицей — допустимы только буквы, пробел и дефис.': 'نام کامل را با حروف سیریلیک وارد کنید — فقط حروف، فاصله و خط تیره مجاز است.',
    'Не выбран музей.': 'موزه‌ای انتخاب نشده است.',
    'Выберите язык: без него заявку на обучение не примут.': 'زبان را انتخاب کنید: بدون آن درخواست آموزش پذیرفته نمی‌شود.',
    'Так записаться можно только на первичное обучение.': 'به این روش فقط می‌توان برای آموزش اولیه ثبت‌نام کرد.',
    'Выбор даты откроется после оплаты обучения.': 'انتخاب تاریخ پس از پرداخت آموزش باز می‌شود.',
    'Введите ФИО полностью.': 'نام کامل را وارد کنید.',
    'Введите корректный телефон.': 'شماره تلفن معتبر وارد کنید.',
    'Введите корректный email.': 'ایمیل معتبر وارد کنید.',
    'Система заявок отклонила запрос. Попробуйте ещё раз или свяжитесь с оператором.': 'سامانه درخواست‌ها درخواست را رد کرد. دوباره تلاش کنید یا با اپراتور تماس بگیرید.',
    'Первичное получение, продление': 'دریافت اولیه، تمدید',
    'Мои договоры': 'قراردادهای من',
    'Подписанных договоров пока нет. Они появятся здесь после оплаты продления или обучения на сайте.': 'هنوز قرارداد امضاشده‌ای نیست. پس از پرداخت تمدید یا آموزش در سایت، اینجا نمایش داده می‌شود.',
    'Здесь можно заказать технические средства ведения экскурсий': 'در اینجا می‌توانید تجهیزات فنی برگزاری تور را سفارش دهید',

    // Прайс-лист с ценами (09.10.2026)
    'Ваши цены': 'قیمت‌های شما',
    'Персональный прайс-лист': 'لیست قیمت شخصی',
    'Общий прайс-лист': 'لیست قیمت عمومی',
    'действует с': 'معتبر از',
    'Объект': 'مورد',
    'Основная цена': 'قیمت پایه',
    'Льготная цена': 'قیمت تخفیفی',
    'Стоимость по прайс-листу:': 'هزینه طبق لیست قیمت:',
    'без учёта:': 'بدون احتساب:',

    // Прайс-листы по категориям групп (12.10.2026)
    'Российские туристы': 'گردشگران روسی',
    'Иностранные туристы': 'گردشگران خارجی',
    'Китайские туристы': 'گردشگران چینی',
    'Школьная группа': 'گروه دانش‌آموزی',
    'Школьные группы': 'گروه‌های دانش‌آموزی',
    'Основная': 'اصلی',
    'Льготная': 'تخفیفی',
    'За группу': 'گروهی',
    'Группа до {n} чел.': 'گروه تا {n} نفر',
    'Экскурсионное обслуживание': 'خدمات راهنمای تور',
    'Обслуживание до {n} чел.': 'خدمات، گروه تا {n} نفر',
    'ЭО': 'راهنما',
    'Экскурсионное обслуживание, за одно': 'خدمات راهنمای تور، هر مورد',
    'экскурсионное обслуживание': 'خدمات راهنمای تور',
    'VIP': 'VIP',
    'за группу': 'برای هر گروه',
    'Нажмите на заголовок, чтобы раскрыть цены, на название музея — его объекты': 'برای دیدن قیمت‌ها روی عنوان و برای دیدن اشیای موزه روی نام آن بزنید',
    'ШКОЛЬНАЯ': 'دانش‌آموزی',
    'Цена за группу': 'قیمت گروهی',
    'до {n} чел.': 'تا {n} نفر',
    'Услуги в заявке в музей': 'خدمات در سفارش موزه',
    'за человека': 'برای هر نفر',
    'за доставку': 'برای هر تحویل',
    'Калькулятор цен': 'ماشین‌حساب قیمت',
    'Выберите музей, объект и количество билетов — стоимость посчитается по вашему прайс-листу': 'موزه، مکان و تعداد بلیت را انتخاب کنید — هزینه طبق لیست قیمت شما محاسبه می‌شود',
    'Дата нужна, чтобы взять прайс-лист, действующий на день посещения': 'تاریخ برای انتخاب لیست قیمت معتبر در روز بازدید لازم است',
    'При группе от {n} человек требуется радиогид': 'برای گروه‌های {n} نفر به بالا رادیوگاید الزامی است',
    'Стоимость': 'هزینه',
    'Выберите музей и объект — расчёт появится здесь': 'موزه و مکان را انتخاب کنید — محاسبه اینجا نمایش داده می‌شود',
    'Укажите количество билетов': 'تعداد بلیت‌ها را وارد کنید',
    'Считаем…': 'در حال محاسبه…',
    'Для этого объекта цены в прайс-листе нет. Сумму рассчитает менеджер после подачи заявки.': 'برای این مکان قیمتی در لیست قیمت نیست. مبلغ پس از ثبت سفارش توسط مدیر محاسبه می‌شود.',
    'Расчёт недоступен: войдите в кабинет заново': 'محاسبه در دسترس نیست: دوباره وارد شوید',
    'Итого': 'جمع کل',
    'У этих услуг нет цены в прайс-листе — её уточнит менеджер.': 'این خدمات در لیست قیمت قیمتی ندارند — مدیر آن را مشخص می‌کند.',
    'Основные билеты': 'بلیت‌های عادی',
    'Льготные билеты': 'بلیت‌های تخفیف‌دار',
    '{n} чел.': '{n} نفر',
    'Хотите рассчитать цену?': 'می‌خواهید قیمت را محاسبه کنید؟',
    'Воспользуйтесь нашим калькулятором: выберите музей, объект и количество билетов — сумма посчитается по вашему прайс-листу.': 'از ماشین‌حساب ما استفاده کنید: موزه، مکان و تعداد بلیت را انتخاب کنید — مبلغ طبق لیست قیمت شما محاسبه می‌شود.',
    'Открыть калькулятор': 'باز کردن ماشین‌حساب',
    'Изменить номер': 'تغییر شماره',
    'Изменить номер лицензии': 'تغییر شماره مجوز',
    'Не удалось изменить номер лицензии. Попробуйте ещё раз.': 'تغییر شماره مجوز انجام نشد. دوباره تلاش کنید.',
    'Расчёт по группам': 'محاسبه بر اساس گروه‌ها',
    'Музеев в расчёте': 'موزه‌ها در محاسبه',
    'Итого по всем группам': 'جمع کل همه گروه‌ها',
    'Очистить расчёт': 'پاک کردن محاسبه',
    'Группа добавлена в расчёт. Выберите следующий музей — количество билетов подставится прежнее.': 'گروه به محاسبه اضافه شد. موزه بعدی را انتخاب کنید — تعداد بلیت‌ها همان قبلی خواهد بود.',
    'чел.': 'نفر',
    'Убрать': 'حذف',
    'Вместе с добавленными группами ({n})': 'همراه با گروه‌های افزوده‌شده ({n})',
    'Расчёт стоимости': 'محاسبه هزینه',
    'Заголовок документа': 'عنوان سند',
    'Не удалось подготовить файл. Попробуйте ещё раз.': 'آماده‌سازی فایل انجام نشد. دوباره تلاش کنید.',
    'доставка': 'تحویل',
    'Скачать расчёт': 'دانلود محاسبه',
    'новое': 'جدید',
    'Подача заявок по расчёту': 'ثبت سفارش‌ها بر اساس محاسبه',
    'На каждый музей уйдёт отдельная заявка. Выберите время посещения и укажите данные гида.': 'برای هر موزه سفارش جداگانه ارسال می‌شود. زمان بازدید را انتخاب و اطلاعات راهنما را وارد کنید.',
    'На эту дату записи нет — измените дату в калькуляторе': 'برای این تاریخ زمانی موجود نیست — تاریخ را در ماشین‌حساب تغییر دهید',
    'выберите время': 'زمان را انتخاب کنید',
    'это время больше недоступно, выберите другое': 'این زمان دیگر در دسترس نیست، زمان دیگری انتخاب کنید',
    'Отправлено заявок: {n}': 'سفارش‌های ارسال‌شده: {n}',
    'Причина': 'دلیل',
    'До сбоя в офис успели уйти заявки {list} — они уже в «Заказах», подавать их заново не нужно.': 'سفارش‌های {list} پیش از خطا به دفتر رسیدند — در «سفارش‌ها» هستند، دوباره ارسال نکنید.',
    'Остальные музеи оставлены в расчёте — исправьте и отправьте заново.': 'موزه‌های باقی‌مانده در محاسبه مانده‌اند — اصلاح و دوباره ارسال کنید.',
    'Успешно': 'موفق',
    'Заявка не отправлена': 'سفارش ارسال نشد',
    'Заявка на эту дату не принимается: не раньше чем за {n} дн. — измените дату в калькуляторе': 'برای این تاریخ سفارش پذیرفته نمی‌شود: حداقل {n} روز زودتر — تاریخ را در ماشین‌حساب تغییر دهید',

    // Калькулятор стоимости лицензий и выбор калькулятора (27.10.2026).
    'Билеты, экскурсионное обслуживание и услуги по вашему прайс-листу. Расчёт можно скачать и сразу подать заявку.': 'بلیت‌ها، خدمات راهنما و سایر خدمات طبق فهرست قیمت شما. می‌توانید محاسبه را دانلود کرده و بلافاصله درخواست دهید.',
    'Выберите, что посчитать': 'انتخاب کنید چه چیزی محاسبه شود',
    'Из них оплачивается в офисе': 'از این مبلغ در دفتر پرداخت می‌شود',
    'К выбору калькулятора': 'بازگشت به انتخاب ماشین‌حساب',
    'К получению лицензий': 'به دریافت مجوزها',
    'Расчёт стоимости заявки': 'محاسبه هزینه درخواست',
    'Расчёт стоимости лицензий': 'محاسبه هزینه مجوزها',
    'Не удалось получить цены. Попробуйте ещё раз.': 'دریافت قیمت‌ها ممکن نشد. دوباره تلاش کنید.',
    'Оплачивается в офисе': 'در دفتر پرداخت می‌شود',
    'Отметьте музеи слева — здесь появится расчёт.': 'موزه‌ها را در سمت چپ علامت بزنید — محاسبه اینجا نمایش داده می‌شود.',
    'Отметьте музеи — стоимость посчитается по ценам текущего сезона': 'موزه‌ها را علامت بزنید — هزینه بر اساس قیمت‌های فصل جاری محاسبه می‌شود',
    'Очистить': 'پاک کردن',
    'Первичное получение (обучение)': 'دریافت اولیه (آموزش)',
    'Продление и получение лицензий по ценам текущего сезона. Расчёт можно скачать и перейти к оплате.': 'تمدید و دریافت مجوزها با قیمت‌های فصل جاری. می‌توانید محاسبه را دانلود کرده و به پرداخت بروید.',
    'Продление лицензии': 'تمدید مجوز',
    'Сезон': 'فصل',
    'Цены на этот сезон пока не заведены. Уточните стоимость по телефону {phone}.': 'قیمت‌های این فصل هنوز تعیین نشده است. هزینه را از طریق تلفن {phone} بپرسید.',
    'лицензий: {n}': 'مجوزها: {n}',
    'Цены на сезон пока нет — уточните по телефону {phone}.': 'قیمت این فصل هنوز تعیین نشده است — از طریق تلفن {phone} بپرسید.',

    // Договор при отметке «Согласие» (28.10.2026).
    'Вы согласились с условиями договора и подписали его {date} в {time}, нажав «Согласие».': 'شما در {date} ساعت {time} با زدن «رضایت» شرایط قرارداد را پذیرفته و آن را امضا کردید.',
    'Договор подписан и сохранён в «Настройках».': 'قرارداد امضا و در «تنظیمات» ذخیره شد.',
    'Договоры оказания услуг, которые вы подписали отметкой «Согласие» при оплате лицензий. Их можно открыть и скачать в любой момент.': 'قراردادهای خدماتی که هنگام پرداخت مجوزها با زدن «رضایت» امضا کرده‌اید. هر زمان می‌توانید آن‌ها را باز و دانلود کنید.',
    'Договоры подписаны и сохранены в «Настройках».': 'قراردادها امضا و در «تنظیمات» ذخیره شدند.',
    'Не удалось сохранить договор. Попробуйте ещё раз.': 'ذخیره قرارداد ممکن نشد. دوباره تلاش کنید.',
    'Подписанных договоров пока нет. Они появятся здесь, как только вы отметите «Согласие» на шаге оплаты продления или обучения.': 'هنوز قرارداد امضاشده‌ای نیست. به محض زدن «رضایت» در مرحله پرداخت تمدید یا آموزش اینجا نمایش داده می‌شود.',
    'После отметки «Согласие» договор сохранится в «Настройках»: его можно открыть и скачать в PDF в любой момент.': 'پس از زدن «رضایت» قرارداد در «تنظیمات» ذخیره می‌شود: هر زمان می‌توانید آن را باز و PDF را دانلود کنید.',
    'После отметки «Согласие» договоры сохранятся в «Настройках»: их можно открыть и скачать в PDF в любой момент.': 'پس از زدن «رضایت» قراردادها در «تنظیمات» ذخیره می‌شوند: هر زمان می‌توانید آن‌ها را باز و PDF را دانلود کنید.',
    'Согласие: я принимаю условия договора возмездного оказания услуг': 'رضایت: شرایط قرارداد خدمات پولی را می‌پذیرم',
    'Согласие: я принимаю условия договоров возмездного оказания услуг': 'رضایت: شرایط قراردادهای خدمات پولی را می‌پذیرم',
    'Сохраняем договор…': 'در حال ذخیره قرارداد…',
    'ожидает оплаты': 'در انتظار پرداخت',
    'от {date}': 'مورخ {date}',

    // Расчёт стоимости: радиогид/аудиогид, итоги в множественных заявках (30.10.2026)
    'Что считаем': 'چه چیزی را محاسبه می‌کنیم',
    'Заявка в музей': 'درخواست موزه',
    'Радиогид в город': 'راهنمای رادیویی در شهر',
    'Радиогид в музей': 'راهنمای رادیویی در موزه',
    'Выберите музей — расчёт появится здесь': 'موزه را انتخاب کنید — محاسبه اینجا نمایش داده می‌شود',
    'Укажите количество аппаратов': 'تعداد دستگاه‌ها را وارد کنید',
    'Для этой услуги цены в прайс-листе нет. Сумму рассчитает менеджер после подачи заказа.': 'برای این خدمت قیمتی در لیست قیمت نیست. مبلغ را مدیر پس از ثبت سفارش محاسبه می‌کند.',
    'Заказать радиогид / аудиогид': 'سفارش راهنمای رادیویی / صوتی',
    'В расчёте есть заказ радиогида или аудиогида: такие заказы подаются в разделе «Радиогид / Аудиогид», заявки в музеи — из расчёта без него.': 'در محاسبه سفارش راهنمای رادیویی یا صوتی وجود دارد: این سفارش‌ها در بخش «راهنمای رادیویی / صوتی» ثبت می‌شوند، درخواست‌های موزه از محاسبه بدون آن ارسال می‌شوند.',
    'Доставка': 'تحویل',
    'за пределами КАД': 'خارج از کمربندی',
    'в пределах КАД': 'داخل کمربندی',
    'доставка в пределах КАД': 'تحویل داخل کمربندی',
    'Аппараты': 'دستگاه‌ها',
    'аппараты': 'دستگاه‌ها',
    'Заказ добавлен в расчёт.': 'سفارش به محاسبه اضافه شد.',
    'оценено музеев: {n} из {total}': 'موزه‌های قیمت‌گذاری‌شده: {n} از {total}',
    'оценено групп: {n} из {total}': 'گروه‌های قیمت‌گذاری‌شده: {n} از {total}',
    'Кол-во аппаратов': 'تعداد دستگاه‌ها',
    'Оформить доставку (услуга платная)': 'سفارش تحویل (خدمت پولی)',
    'Доставка в пределах КАД': 'تحویل داخل کمربندی',
    'Доставка за пределы КАД': 'تحویل خارج از کمربندی',
}
